import { render } from "./FrequencyChart.vue?vue&type=template&id=8952134e"
import script from "./FrequencyChart.vue?vue&type=script&lang=js"
export * from "./FrequencyChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__